<template>
<div class="double-line-wrap">
    <div ref="progressLine" style="width:100%;height:100%;"></div>
    <div class="bottom-title-wrap">
        <div class="double-bottom-title">游离钙</div>
    </div>
</div>
</template>

<script>
import httpUrl from '../../../views/httpUrl'
import {progressLineOption} from "./progressLineOption"

export default {
    name: "progress-line",
    data() {
        return {
            option: progressLineOption,
            timeOut:null,
        }
    },
    mounted() {
        let _this =this
        _this.getStrength();
        _this.timeOut = setInterval(function () {
            _this.getStrength()
        }, 1800000);
    },
    destroyed(){
        if (this.timeOut) {
        clearTimeout(this.timeOut)
        }
    },
    methods: {
        getStrength(){
            this.$myHttp.get(httpUrl.home.ZLDate+'/fcao').then(res => {
                let timesX=[],datas=[]
                res.data.fcao.forEach(element => {
                    timesX.push(element.dateTime.substring(5,element.dateTime.length));
                    datas.push(Number(element.f_CaO).toFixed(2))
                   
                })
                this.option.xAxis.data = timesX;
                this.option.series[0].data = datas;
                this.generateprogressLine()
            }).catch(res => {})
        },
        generateprogressLine() {
            let progressLine = this.$echarts.init(this.$refs.progressLine);
            window.onresize = progressLine.resize;
            progressLine.setOption(this.option);
        }
    }
}
</script>

<style scoped>
.double-line-wrap {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.bottom-title-wrap {
    display: flex;
    justify-content: center;
}

.double-bottom-title {
    width: 126px;
    font-size: 16px;
    text-align: center;
    background: url("../../../assets/picture/center/isosceles.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/home/centerBottom/progressLine.vue